import { render, staticRenderFns } from "./NuevaReferenciaLaboralDialogComponent.vue?vue&type=template&id=307aa197"
import script from "./NuevaReferenciaLaboralDialogComponent.vue?vue&type=script&lang=js"
export * from "./NuevaReferenciaLaboralDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports